import { QueryClient } from '@tanstack/react-query';

import { isApiError } from './apiError';

/**
 * Determine if a query should be retried.
 *
 * - Network errors: retry up to 1 time.
 * - 4xx (client errors): never retry.
 * - 5xx (server errors): retry up to 1 time.
 */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 1) return false;

  if (isApiError(error)) {
    if (error.status >= 400 && error.status < 500) return false;
    return true; // network error (status 0) or 5xx
  }

  return true;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: shouldRetry,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
